import React from 'react';
import pic from '../../assets/images/seller.png';

const SellerIcon = () => (
  <img
    src={pic}
    alt="Seller Icon"
    style={{
      width: '100%',
      height: 'auto', // Maintain aspect ratio
      objectFit: 'contain',
      display: 'block', // Ensure it behaves like a block element
    }}
  />
);

export default SellerIcon;
